import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useAuth } from "./AuthContext";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const OWNER_EMAIL = "torregrossa.joseph@gmail.com";

const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const email = user?.email || "";
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null);

  const checkSubscription = useCallback(async (emailToCheck) => {
    if (!emailToCheck) {
      setIsSubscribed(false);
      setSubscription(null);
      setLoading(false);
      return false;
    }
    if (emailToCheck === OWNER_EMAIL) {
      setIsSubscribed(true);
      setSubscription({ plan: "owner", status: "active", email: emailToCheck });
      setLoading(false);
      return true;
    }
    try {
      const res = await axios.get(`${API}/subscription/check`, { params: { email: emailToCheck } });
      const active = res.data.active === true;
      setIsSubscribed(active);
      setSubscription(active ? res.data.subscription : null);
      setLoading(false);
      return active;
    } catch {
      setIsSubscribed(false);
      setSubscription(null);
      setLoading(false);
      return false;
    }
  }, []);

  useEffect(() => {
    checkSubscription(email);
  }, [email, checkSubscription]);

  const refresh = useCallback(() => {
    return checkSubscription(email);
  }, [email, checkSubscription]);

  return (
    <SubscriptionContext.Provider value={{ email, isSubscribed, loading, subscription, refresh, checkSubscription }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) throw new Error("useSubscription must be used within SubscriptionProvider");
  return ctx;
}
